// extracted by mini-css-extract-plugin
module.exports = {"pszauan":"pszauan","tej3rqq":"tej3rqq","h1kry386":"h1kry386"};